import '/home/runner/work/dialog/dialog/docs/demo/ant-design.md?watch=parent';
export const toc = new Proxy([], {});
export const frontmatter = new Proxy({"title":"ant-design","toc":"menu","filename":"docs/demo/ant-design.md","lastUpdated":1785141763000,"nav":{"title":"Demo","path":"/demo"}}, {});

export const demoIndex = {
  ids: ["docs-demo-ant-design-demo-ant-design"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/ant-design.md?type=demo')
};